import { render, staticRenderFns } from "./layer-allocation-room.vue?vue&type=template&id=ba1e4d6a&scoped=true&"
import script from "./layer-allocation-room.vue?vue&type=script&lang=js&"
export * from "./layer-allocation-room.vue?vue&type=script&lang=js&"
import style0 from "./layer-allocation-room.vue?vue&type=style&index=0&id=ba1e4d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1e4d6a",
  null
  
)

export default component.exports